import React, { useState } from 'react';
import { ChevronRight, Brain } from 'lucide-react';

export default function TextReasoningDropdown({
  reasoningText,
  isReasoning = false,
}) {
  const [open, setOpen] = useState(false);

  if (!reasoningText) return null;

  return (
    <div className="mb-3 w-full max-w-3xl">
      <button
        onClick={() => setOpen((p) => !p)}
        className="group flex items-center gap-1.5 py-0.5 text-xs text-zinc-500 transition-colors hover:text-zinc-300"
        aria-expanded={open}
      >
        {isReasoning ? (
          <span className="relative flex h-3 w-3 shrink-0 items-center justify-center">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-violet-400 opacity-30" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-violet-400" />
          </span>
        ) : (
          <Brain className="h-3.5 w-3.5 shrink-0 text-zinc-500 group-hover:text-zinc-400" />
        )}
        <span className="font-medium">
          {isReasoning ? 'Thinking...' : 'Thinking'}
        </span>
        <ChevronRight
          className={`h-3 w-3 shrink-0 transition-transform duration-200 ${open ? 'rotate-90' : ''}`}
        />
      </button>

      {open && (
        <div className="mt-2 flex gap-3 pl-0.5">
          <div className="w-px shrink-0 self-stretch rounded-full bg-zinc-700" />
          <p className="min-w-0 flex-1 whitespace-pre-wrap break-words text-xs leading-relaxed text-zinc-400">
            {reasoningText?.trim()}
          </p>
        </div>
      )}
    </div>
  );
}
